import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageBanner',
  props: {
    icon: { default: "$icon_attention" },
    iconSize: { default: 32 },
    color: { default: "warning" }
  },
  setup(__props: any) {

const props = __props as { icon: string, iconSize: number, color: string };



return { __sfc: true,props }
}

})